/**
 * Capture search normalisation — the single place that decides which characters
 * a Capture search query and its haystack ignore.
 *
 * CAP-6 requires search to be punctuation-insensitive: "Hello!" must match
 * "Hello" regardless of which side the punctuation sits on.
 *
 * It must NOT be emoji-insensitive. Emoji are Unicode `So` (Symbol, other), so
 * a blanket `\p{S}` strip erased them from BOTH the query and the haystack.
 * An all-emoji query then normalised to the empty string, and an empty query
 * means "match everything" — so searching a Capture inbox for an emoji that
 * appears in exactly one note returned the WHOLE inbox. Measured live on
 * web-stg 2026-08-01: query "🎯" returned all 8 items while "qqqq" correctly
 * returned 0.
 *
 * So we strip punctuation (`\p{P}`) plus the non-pictographic symbol classes
 * (`\p{Sm}` math, `\p{Sc}` currency, `\p{Sk}` modifier) and deliberately keep
 * `\p{So}`, which is where emoji live. Letters, numbers and whitespace are
 * untouched, exactly as before.
 */
export const normalizeCaptureSearch = (value) =>
  (value || "").replace(/[\p{P}\p{Sm}\p{Sc}\p{Sk}]/gu, "");

export default normalizeCaptureSearch;
